import { toastSuccess } from ".";

/**
 * Copies text to device clipboard
 *
 * @param {string} text
 * @returns {string}
 */
export const copyTextToClipboard = async (text) => {
  if ("clipboard" in navigator) {
    await navigator.clipboard.writeText(text);
    toastSuccess("Copied text");
  } else {
    document.execCommand("copy", true, text);
    toastSuccess("Copied text");
  }
};
